import React, { FunctionComponent } from "react";
import { Redirect, Route } from "react-router-dom";
import {apiEndpoint} from "../../Constants/api";

import Api from "../../helpers/apiHelpers";

const AdminRoute: FunctionComponent<{[x: string]: any;}> = ({children, ...rest}) => {
    return (
        Api.isLoggedIn && Api.role === "ADMIN" ?
            (
                <Route {...rest}>
                    {children}
                </Route>
            )
            :
            <Redirect to={`${apiEndpoint}login`} />
    );
};

export default AdminRoute;